module.exports = __webpack_public_path__ + "static/whitemuslin-43b46c2a7e3072cafad6789a1d3c713d.jpeg";